import { PaymentsAndSubscriptions } from 'src/pages/NewBillingModule/paymentsAndSubscriptions';
import { BillingCredentialManagementPage } from 'src/pages/BillingCreadentialManagmentPage';
import { ReccuringChargesTable } from 'src/components/allocations/ReccuringChargesTable';
import { ConfirmChangeEmailPage } from 'src/pages/ConfirmChangeEmailPage';
import { InformationBannersPage } from 'src/pages/InformationBannersPage';
import { ResetPasswordSetPage } from 'src/pages/ResetPasswordSetPage';
import { CompanyRedirectPage } from 'src/pages/CompanyRedirectPage';
import { ProfileSettingsPage } from 'src/pages/ProfileSettingsPage';
import { CompanyDetailsPage } from 'src/pages/CompanyDetailsPage';
import { ConfirmAccountPage } from 'src/pages/ConfirmAccountPage';
import { AddendumsFilesPage } from 'src/pages/AddendumsFilesPage';
import { styleGuideAccess } from 'src/configs/getAppPartsAccess';
import { ResetPasswordPage } from 'src/pages/ResetPasswordPage';
import { TwoFactorAuthPage } from 'src/pages/TwoFactorAuthPage';
import { UtilityBillsPage } from 'src/pages/UtilityBillsPage';
import { NewBillingModule } from 'src/pages/NewBillingModule';
import { PropertyEditPage } from 'src/pages/PropertyEditPage';
import { FileCabinetPage } from 'src/pages/FileCabinetPage';
import { PropertyAddPage } from 'src/pages/PropertyAddPage';
import { PropertiesPage } from 'src/pages/PropertiesPage';
import { ProPricingPage } from 'src/pages/ProPricingPage';
import { BillsPage } from 'src/pages/BillsPage';
import { DashboardPage } from 'src/pages/DashboardPage';
import { ResidentsPage } from 'src/pages/ResidentsPage';
import { AppfolioPage } from 'src/pages/AppfolioPage';
import { PMSignUpPage } from 'src/pages/PMSignUpPage';
import { PaymentsPage } from 'src/pages/PaymentsPage';
import { LoginPage } from 'src/pages/LoginPage';
import { AdminPage } from '../pages/AdminPage';
import { LivyPage } from '../pages/LivyPage';
import { LivyKbPage } from '../pages/LivyKbPage';
import { LivySupportPage } from '../pages/LivySupportPage';
import { LivyAdminPage } from '../pages/LivyAdminPage';
import { BillQueuePage } from '../pages/AdminPage/BillQueue';
import UserAcknowledgmentPage from 'src/pages/TextPages/UserAcknowledgmentPage';
import AllocationHistory from 'src/pages/AllocationsPage/AllocationHistory';
import ResetPasswordRequestPage from 'src/pages/ResetPasswordRequestPage';
import ResetPasswordSuccessPage from 'src/pages/ResetPasswordSuccessPage';
import TermsOfServicePage from 'src/pages/TextPages/TermsOfServicePage';
import PrivacyPolicyPage from 'src/pages/TextPages/PrivacyPolicyPage';
import AllocationTablesPage from 'src/pages/AllocationTablesPage';
import ResidentProfilePage from 'src/pages/ResidentProfilePage';
import NotificationsPage from 'src/pages/NotificationsPage';
import ProfileLoaderPage from 'src/pages/ProfileLoaderPage';
import PaygateLoaderPage from 'src/pages/PaygateLoaderPage';
import ProfileSavedPage from 'src/pages/ProfileSavedPage';
import TeamSettingsPage from 'src/pages/TeamSettingsPage';
import FeeStructurePage from 'src/pages/FeeStructurePage';
import AllocationsPage from 'src/pages/AllocationsPage';
import ReportingPage from 'src/pages/ReportingPage';
import ErrorPage from 'src/pages/ErrorPage';
import ARPage from 'src/pages/ARPage';
import LvUtilitiesIcons from 'src/guide/UtilitiesIconsPage';
import StyleGuidePage from 'src/guide/StyleGuidePage';
import LvDatePickers from 'src/guide/DatePickersPage';
import LvNavigation from 'src/guide/NavigationPage';
import LvIconsState from 'src/guide/IconsStatePage';
import LvTooltips from 'src/guide/TooltipsPage';
import LvButtons from 'src/guide/ButtonsPage';
import LvSelects from 'src/guide/SelectsPage';
import LvLoaders from 'src/guide/LoadersPage';
import LvInputs from 'src/guide/InputsPage';
import LvAlerts from 'src/guide/AlertsPage';
import LvModals from 'src/guide/ModalsPage';
import LvStatus from 'src/guide/StatusPage';
import LvIcons from 'src/guide/IconsPage';
export const ROUTES_TYPES = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  RESTRICTED: 'RESTRICTED'
};
export const RESTRICTED_TYPES = {
  DESIGN: 'DESIGN',
  STANDARD: 'STANDARD',
  MFA: 'MFA',
  PAYGATE: 'PAYGATE',
  PROFILE_SAVED: 'PROFILE_SAVED',
  CONFIRM_ACCOUNT: 'CONFIRM_ACCOUNT',
  COMPANY_DETAILS: 'COMPANY_DETAILS'
};
export const allocationsRoutes = [{
  label: 'Allocations',
  path: '/allocations/allocations_charges',
  isTabletReady: true,
  component: ReccuringChargesTable,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Allocations',
  path: '/allocations/allocations_history',
  isTabletReady: true,
  component: AllocationHistory,
  routeType: ROUTES_TYPES.PRIVATE
}];
const routes = [{
  label: 'Style Guide',
  path: '/style-guide',
  component: StyleGuidePage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Buttons',
  path: '/buttons',
  component: LvButtons,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Modals',
  path: '/modals',
  component: LvModals,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Navigation',
  path: '/navigation',
  component: LvNavigation,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Inputs',
  path: '/inputs',
  component: LvInputs,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Datepickers',
  path: '/datepickers',
  component: LvDatePickers,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Alerts',
  path: '/alerts',
  component: LvAlerts,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Tooltips',
  path: '/tooltips',
  component: LvTooltips,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Chips',
  path: '/status',
  component: LvStatus,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Selects',
  path: '/selects',
  component: LvSelects,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Icons',
  path: '/icons',
  component: LvIcons,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Icons state',
  path: '/icons-state',
  component: LvIconsState,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Loaders',
  path: '/loaders',
  component: LvLoaders,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Utilities icons',
  path: '/utilities-icons',
  component: LvUtilitiesIcons,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.DESIGN,
  disabled: !styleGuideAccess
}, {
  label: 'Error page',
  path: '/error_page',
  divider: true,
  isTabletReady: true,
  component: ErrorPage,
  routeType: ROUTES_TYPES.PUBLIC,
  disabled: !styleGuideAccess
}, {
  label: 'Sign Up',
  path: '/',
  isTabletReady: true,
  component: PMSignUpPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.STANDARD
}, {
  label: 'Profile Saved Page',
  path: '/profile_saved',
  isTabletReady: true,
  component: ProfileSavedPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.PROFILE_SAVED
}, {
  label: 'Processing profile',
  path: '/processing_profile',
  isTabletReady: true,
  component: ProfileLoaderPage,
  routeType: ROUTES_TYPES.DESIGN
}, {
  label: 'Confirm Email Change',
  path: '/confirm_email_change',
  isTabletReady: true,
  component: ConfirmChangeEmailPage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'Two factor auth',
  path: '/two_factor_auth',
  isTabletReady: true,
  component: ConfirmAccountPage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'Two factor auth MFA',
  path: '/mfa',
  isTabletReady: true,
  component: TwoFactorAuthPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.MFA
}, {
  label: 'Company details',
  path: '/company_details',
  isTabletReady: true,
  component: CompanyDetailsPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.COMPANY_DETAILS
}, {
  label: 'Payment information',
  path: '/paygate',
  isTabletReady: true,
  component: PaygateLoaderPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.PAYGATE
}, {
  label: 'Active Dashboard',
  path: '/active_dashboard',
  isTabletReady: true,
  divider: true,
  component: DashboardPage,
  routeType: ROUTES_TYPES.PRIVATE
},, {
  label: 'Company Redirect',
  path: '/companyredirect/:companyId',
  isTabletReady: true,
  divider: true,
  component: CompanyRedirectPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Add new property',
  isTabletReady: true,
  path: '/new_property',
  component: PropertyAddPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Edit property',
  divider: true,
  isTabletReady: true,
  path: '/edit_property',
  component: PropertyEditPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Building (Residencies)',
  path: '/residencies',
  isTabletReady: true,
  component: ResidentsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Building (Residencies)',
  path: '/new_properties',
  isTabletReady: true,
  component: PropertiesPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Resident Account Profile',
  path: '/resident_acount',
  isTabletReady: true,
  component: ResidentProfilePage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Allocations',
  path: '/allocations',
  isTabletReady: true,
  component: AllocationsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'New Billing Module',
  path: '/billing_module',
  isTabletReady: true,
  component: NewBillingModule,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Payments & subscriptions',
  path: '/payments_and_subscriptions',
  isTabletReady: true,
  component: PaymentsAndSubscriptions,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Allocation Tables',
  path: '/allocation_tables',
  isTabletReady: true,
  component: AllocationTablesPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'File cabinet',
  path: '/file_cabinet',
  isTabletReady: true,
  component: FileCabinetPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Admin',
  path: '/admin',
  isTabletReady: true,
  component: AdminPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  // Admin-gated inside the page itself for the initial rollout; every Livy surface ships
  // behind LivableAdmin/LivableSuperAdmin and un-gates progressively.
  label: 'Livy',
  path: '/livy',
  isTabletReady: true,
  component: LivyPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Livy knowledge base',
  path: '/livy/kb',
  component: LivyKbPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Livy support',
  path: '/livy/support',
  component: LivySupportPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Livy activity',
  path: '/livy/admin',
  component: LivyAdminPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  // Also a tab on /admin. This route stays because the Livy palette links to it and operators
  // bookmark it. The page itself refuses non-staff, and every endpoint behind it is AdminOrHigher.
  label: 'Bill queue',
  path: '/bill-queue',
  isTabletReady: true,
  component: BillQueuePage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Pro Pricing',
  path: '/pro-pricing',
  isTabletReady: true,
  component: ProPricingPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Bills',
  path: '/bills',
  isTabletReady: true,
  component: BillsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Addendums files',
  path: '/addendums_files',
  isTabletReady: true,
  component: AddendumsFilesPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Utility bills files',
  path: '/bills_files',
  isTabletReady: true,
  component: UtilityBillsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Reporting',
  path: '/reporting',
  isTabletReady: true,
  component: ReportingPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'AR page',
  path: '/ar_report',
  divider: true,
  isTabletReady: true,
  component: ARPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Settings (Team)',
  path: '/team_settings',
  isTabletReady: true,
  component: TeamSettingsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Settings (Fee structure)',
  path: '/fee-structure',
  isTabletReady: true,
  component: FeeStructurePage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Settings (Profile)',
  path: '/profile-settings',
  isTabletReady: true,
  component: ProfileSettingsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Payments',
  path: '/payments',
  isTabletReady: true,
  component: PaymentsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Information Banners Page',
  path: '/information_banners',
  isTabletReady: true,
  component: InformationBannersPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Appfolio',
  path: '/appfolio',
  isTabletReady: true,
  component: AppfolioPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Notifications',
  path: '/notifications',
  divider: true,
  isTabletReady: true,
  component: NotificationsPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Billing Credentials',
  path: '/auto_billing_credentials',
  isTabletReady: true,
  divider: true,
  component: BillingCredentialManagementPage,
  routeType: ROUTES_TYPES.PRIVATE
}, {
  label: 'Login',
  path: '/login',
  isTabletReady: true,
  component: LoginPage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'Reset password',
  path: '/reset_password',
  isTabletReady: true,
  component: ResetPasswordPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.STANDARD
}, {
  label: 'Request password',
  path: '/reset_request',
  isTabletReady: true,
  component: ResetPasswordRequestPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.STANDARD
}, {
  label: 'Set New Password',
  path: '/set_password',
  isTabletReady: true,
  component: ResetPasswordSetPage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'Password success',
  path: '/password_success',
  isTabletReady: true,
  component: ResetPasswordSuccessPage,
  routeType: ROUTES_TYPES.RESTRICTED,
  restrictedType: RESTRICTED_TYPES.STANDARD
}, {
  label: 'Terms Of Service Page',
  path: '/termsofservice',
  isTabletReady: true,
  component: TermsOfServicePage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'Privacy Policy Page',
  path: '/privacypolicy',
  isTabletReady: true,
  component: PrivacyPolicyPage,
  routeType: ROUTES_TYPES.PUBLIC
}, {
  label: 'User Acknowledgment Page',
  path: '/useracknowledgment',
  isTabletReady: true,
  component: UserAcknowledgmentPage,
  routeType: ROUTES_TYPES.PUBLIC
}];
export default routes;